import React, { useState, useEffect } from 'react';
import { SAMPLE_EXECUTIONS } from '../data/sampleWorkflows';

export default function Executions() {
  const [executions, setExecutions] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    // Load sample executions
    setExecutions(SAMPLE_EXECUTIONS);
  }, []);

  const filteredExecutions = filter === 'all'
    ? executions
    : executions.filter(e => e.status === filter);

  const getStatusColor = (status) => {
    switch(status) {
      case 'success': return 'bg-green-100 text-green-800';
      case 'failed': return 'bg-red-100 text-red-800';
      case 'running': return 'bg-yellow-100 text-yellow-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusIcon = (status) => {
    switch(status) {
      case 'success': return '✓';
      case 'failed': return '✗';
      case 'running': return '⟳';
      default: return '◯';
    }
  };

  return (
    <div className="flex-1">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Workflow Executions</h2>
          <p className="text-gray-600">Monitor workflow runs and view logs</p>
        </div>

        {/* Filters */}
        <div className="card p-4 mb-6">
          <div className="flex gap-3 flex-wrap">
            <button
              onClick={() => setFilter('all')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${filter === 'all' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700'}`}
            >
              All ({executions.length})
            </button>
            <button
              onClick={() => setFilter('success')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${filter === 'success' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'}`}
            >
              Successful ({executions.filter(e => e.status === 'success').length})
            </button>
            <button
              onClick={() => setFilter('failed')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${filter === 'failed' ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-700'}`}
            >
              Failed ({executions.filter(e => e.status === 'failed').length})
            </button>
          </div>
        </div>

        {/* Executions List */}
        <div className="card p-6">
          {filteredExecutions.length === 0 ? (
            <div className="py-12 text-center text-gray-500">
              <p className="text-lg font-medium mb-2">📊 No executions found</p>
              <p className="text-sm">Run a workflow to see execution history here</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="border-b border-gray-200">
                  <tr className="text-left text-gray-700 font-semibold">
                    <th className="pb-3 pl-0">Workflow</th>
                    <th className="pb-3">Status</th>
                    <th className="pb-3">Started</th>
                    <th className="pb-3">Duration</th>
                    <th className="pb-3">Steps</th>
                    <th className="pb-3">Errors</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredExecutions.map((exec) => (
                    <tr key={exec.id} className="hover:bg-gray-50 transition-colors">
                      <td className="py-4 pl-0 font-semibold text-gray-900">{exec.workflowName}</td>
                      <td className="py-4">
                        <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(exec.status)}`}>
                          {getStatusIcon(exec.status)} {exec.status}
                        </span>
                      </td>
                      <td className="py-4 text-gray-600 text-xs">
                        {new Date(exec.startedAt).toLocaleString()}
                      </td>
                      <td className="py-4 text-gray-600">{exec.duration}</td>
                      <td className="py-4 text-gray-600">{exec.steps}</td>
                      <td className="py-4">
                        {exec.errors > 0 ? (
                          <span className="badge badge-error">{exec.errors}</span>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
